import type { ColDef } from '@/types/common.types';

// `frequency` entra con D-3 (aprobada el 2026-08-02): el prototipo la tiene y se decidió
// igualarlo. Sale de `activeDays` — ver la nota de origen del dato en `surveyFrequency.ts`.
export const FUND_COLS: ColDef[] = [
  { key: 'name',      labelKey: 'admin.colName',      locked: true },
  { key: 'questions', labelKey: 'admin.colQuestions'               },
  { key: 'status',    labelKey: 'admin.colStatus'                  },
  { key: 'audience',  labelKey: 'admin.colAudience'                },
  { key: 'frequency', labelKey: 'admin.colFrequency'               },
  { key: 'createdBy', labelKey: 'admin.colCreatedBy'               },
  { key: 'feedback',  labelKey: 'admin.colFeedback'                },
  { key: 'period',    labelKey: 'admin.colPeriod'                  },
  { key: 'actions',   labelKey: 'admin.colActions',   locked: true },
];

export const PERS_COLS: ColDef[] = [
  { key: 'name',      labelKey: 'admin.colName',      locked: true },
  { key: 'createdBy', labelKey: 'admin.colCreatedBy'               },
  { key: 'status',    labelKey: 'admin.colStatus'                  },
  { key: 'audience',  labelKey: 'admin.colAudience'                },
  { key: 'frequency', labelKey: 'admin.colFrequency'               },
  { key: 'questions', labelKey: 'admin.colQuestions'               },
  { key: 'feedback',  labelKey: 'admin.colFeedback'                },
  { key: 'period',    labelKey: 'admin.colPeriod'                  },
  { key: 'actions',   labelKey: 'admin.colActions',   locked: true },
];
